export const trendingTopics = [
  { 
    id: 1,
    category: "Sports", 
    title: "FIFA World Cup 2026",
    posts: '10.3k' 
  },
  { 
    id: 2,
    category: "Music", 
    title: "BZRP",
    posts: '7,349'  
  },
  { 
    id: 3,
    category: "Technology", 
    title: "iPhone 14",
    posts: '42.5k' 
  },
  { 
    id: 4,
    category: "Movies", 
    title: "Academy Awards 2023",
    posts: '2,605'  
  },
  { 
    id: 5,
    category: "Entertainment", 
    title: "The Good Doctor",
    posts: '8,879'  
  },
  { 
    id: 6,
    category: "Environment", 
    title: "Climate Change and International Summit",
    posts: '156k'  
  },
  { 
    id: 7,
    category: "Science", 
    title: "Exoplanets",
    posts: '40.8k' 
  },
  { 
    id: 8,
    category: "Fashion", 
    title: "Pull&Bear",
    posts: '4,654' 
  },
  { 
    id: 9,
    category: "Economy", 
    title: "Rising Cryptocurrency Market",
    posts: '259k' 
  },
  { 
    id: 10,
    category: "Environment", 
    title: "Forest Fires and Conservation",
    posts: '30.4k'  
  },
  { 
    id: 11,
    category: "Entertainment", 
    title: "LUPIN",
    posts: '8,642' 
  },
  { 
    id: 12,
    category: "Education", 
    title: "New Education Policies",
    posts: '1,287' 
  },
  { 
    id: 13,
    category: "Entertainment", 
    title: "Reviews of the Latest Netflix Series",
    posts: '28.9k'  
  },
  { 
    id: 14,
    category: "Entrepreneurship", 
    title: "Success Stories of Startups",
    posts: '4,722'  
  },
  { 
    id: 15,
    category: "Art", 
    title: "Contemporary Art Exhibition",
    posts: '1,640'  
  },
  { 
    id: 16,
    category: "Sports", 
    title: "Camp Nou",
    posts: '10.5k'  
  },
  { 
    id: 17,
    category: "Nutrition", 
    title: "Trends in Healthy Eating",
    posts: '3,821' 
  },
  { 
    id: 18,
    category: "Space", 
    title: "Mission to Mars and Space Exploration",
    posts: '124k' 
  },
  { 
    id: 19,
    category: "Wellness", 
    title: "Meditation",
    posts: '2,501' 
  }
];
